import {useCallback, useMemo, useReducer as ReactReducer, useRef} from "react";
import {Payload, State} from "./CopilotContainer.interfaces";
import {TextGeneratorLength, TextGeneratorTone} from "../../../../Interfaces/TextGenerator";

const reduce = (state: State, payloads: Array<Payload>) => {
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case "setOpen":
                state.open = payload.value;
                break;
            case "setIsGenerating":
                state.isGenerating = payload.value;
                break;
            case "setTone":
                state.tone = payload.value;
                break;
            case "setLength":
                state.length = payload.value;
                break;
            case "setInstruction":
                state.instruction = payload.value;
                break;
            default:
                throw new Error("Payload type " + payloadType + " not implemented");
        }
    });
}

const getInitialState = (): State => {
    return {
        open: false,
        tone: TextGeneratorTone.Neutral,
        length: TextGeneratorLength.Medium,
        isGenerating: false,
        instruction: "",
    }
}

export const useReducer = () => {
    const initialState = useMemo(() => getInitialState(), []);
    const stateRef = useRef<Readonly<State>>(initialState);
    const [, render] = ReactReducer(() => [], []);

    const dispatch = useCallback((payload: Payload | Array<Payload>, reRender?: boolean) => {
        reduce(stateRef.current, Array.isArray(payload) ? payload : [payload]);
        if (reRender === undefined || reRender) render();
    }, []);

    return {state: stateRef.current, dispatch};
}